import React, { useState } from "react";
import { Box, Dialog, Typography } from "@mui/material";
import InputWithLabel from "../../shared/components/InputWithLabel";
import CustomPrimaryButton from "../../shared/components/CustomPrimaryButton";
import * as api from "../../api";
import { addServer } from "../../store/actions/roomActions";
import { connect } from "react-redux";

const CreateServerDialog = ({ open, onClose, addServer }) => {
  const [name, setName] = useState("");

  const handleCreate = async () => {
    const response = await api.createServer({ name: name.trim() });
    if (!response.error) {
      addServer(response.data.server);
      setName("");
      onClose();
    }
  };

  return (
    <Dialog
      open={open}
      onClose={onClose}
      PaperProps={{
        sx: {
          bgcolor: "#282a30",
          color: "#f2f3f5",
          borderRadius: "8px",
          width: "420px",
          p: "24px",
        },
      }}
    >
      <Typography sx={{ fontSize: "20px", fontWeight: 700 }}>
        Создать сервер
      </Typography>
      <Typography sx={{ color: "#b5bac1", mt: "8px", fontSize: "14px" }}>
        Будут созданы текстовый канал #общий и голосовой канал.
      </Typography>
      <InputWithLabel
        label="Название сервера"
        type="text"
        value={name}
        setValue={setName}
        placeholder="Например: Команда"
      />
      <Box sx={{ display: "flex", gap: "12px", mt: "22px" }}>
        <CustomPrimaryButton
          label="Отмена"
          onClick={onClose}
          additionalStyles={{ background: "#4e5058" }}
        />
        <CustomPrimaryButton
          label="Создать"
          onClick={handleCreate}
          disabled={name.trim().length < 2}
        />
      </Box>
    </Dialog>
  );
};

export default connect(null, { addServer })(CreateServerDialog);
